import React from 'react';

import ListItem from 'components/ListItem';
import { numberToOrdinal } from 'utils/formatter/number-to-ordinal';

interface OwnProps {
    orderIntoTank: number;
}

export type Props = OwnProps;

export default class FertilizerEventOrderIntoTankListItem extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { orderIntoTank } = this.props;

        return (
            <ListItem
                value={numberToOrdinal(orderIntoTank)}
                description="Order into tank"
            />
        );
    }
}
